import { http, withoutAccessHttp } from "../http-common";
import { PageableResponse } from "../types/pagination";

export interface INegativeProposalReason {
  id: number;
  text: string;
  isActive: boolean;
  isPublic: boolean;
  isOther: boolean;
  createdAt: string;
  createdBy?: string;
  updatedAt?: string;
  updatedBy?: string;
}

export interface INegativeSurveySelectionRequest {
  proposalId: number;
  reasonId: number;
  reasonText?: string;
}

export interface INegativeSurveySelectionResponse {
  applied: boolean;
  message: string;
}

const list = (params?: any) => {
  const queryParams = {
    ...(params || {}),
    page: params?.page ?? 0,
    size: params?.size ?? 10,
  };
  return http.get<PageableResponse<INegativeProposalReason>>("/negative-proposal-reasons", {
    params: queryParams,
  });
};

const listAll = (params?: any) => {
  return http.get<INegativeProposalReason[]>("/negative-proposal-reasons/list", {
    params,
  });
};

const create = (data: any) => {
  return http.post<INegativeProposalReason>("/negative-proposal-reasons", data);
};

const update = (id: number, data: any) => {
  return http.put<INegativeProposalReason>(`/negative-proposal-reasons/${id}`, data);
};

const remove = (id: number) => {
  return http.delete(`/negative-proposal-reasons/${id}`);
};

const submitPublicSurveySelection = (data: INegativeSurveySelectionRequest) => {
  return withoutAccessHttp.post<INegativeSurveySelectionResponse>(
    "/negative-proposal-reasons/public/survey-selection",
    data,
  );
};

const listPublicSurveyReasons = () => {
  return withoutAccessHttp.get<INegativeProposalReason[]>(
    "/negative-proposal-reasons/public/survey-reasons",
  );
};

const NegativeProposalReasonService = {
  list,
  listAll,
  create,
  update,
  remove,
  listPublicSurveyReasons,
  submitPublicSurveySelection,
};

export default NegativeProposalReasonService;
